import urlJoin from 'proper-url-join';

const getItemImage = (subDomain: string | undefined, imageName: string | undefined) =>
  urlJoin(process.env.NEXT_PUBLIC_STORAGE_URL, imageName ? `${subDomain}/${imageName}` : 'temp.png');

const getIcon = () => urlJoin(process.env.NEXT_PUBLIC_STORAGE_URL, 'icon.png');

const getLandingImage = (imageName: string) =>
  urlJoin(process.env.NEXT_PUBLIC_STORAGE_URL, 'landings', imageName);

const getCoverImage = (imageName: string) => urlJoin(process.env.NEXT_PUBLIC_STORAGE_URL, imageName);

const storageUtil = { getItemImage, getIcon, getLandingImage, getCoverImage };

export default storageUtil;
